// Real before/after gallery images grouped by category, used per treatment slug.
const FACE_IMGS = [
  'https://natural.clinic/wp-content/uploads/2025/12/rhinoplasty-before-and-after-turkey-2-1024x1024-2.webp',
  'https://natural.clinic/wp-content/uploads/2025/12/rhinoplasty-before-and-after-turkey-17-1024x1024.jpg.webp',
  'https://natural.clinic/wp-content/uploads/2025/12/rhinoplasty-before-and-after-turkey-18-1024x1024.jpg.webp',
  'https://natural.clinic/wp-content/uploads/2025/12/rhinoplasty-before-and-after-turkey-15-1-1024x1024.jpg.webp',
  'https://natural.clinic/wp-content/uploads/2025/12/rhinoplasty-before-and-after-turkey-16-1024x1024.jpg.webp',
  'https://natural.clinic/wp-content/uploads/2025/12/rhinoplasty-before-and-after-turkey-3-1024x1024.jpg.webp',
  'https://natural.clinic/wp-content/uploads/2025/12/rhinoplasty-before-and-after-turkey-14-1-1024x1024.jpg.webp',
  'https://natural.clinic/wp-content/uploads/2025/12/rhinoplasty-before-and-after-turkey-2-1024x1024-4.webp',
];
const BODY_IMGS = [
  'https://natural.clinic/wp-content/uploads/2025/11/11-1024x1024.jpg.webp',
  'https://natural.clinic/wp-content/uploads/2025/11/9-1024x1024.jpg.webp',
  'https://natural.clinic/wp-content/uploads/2025/11/8-1024x1024.jpg.webp',
  'https://natural.clinic/wp-content/uploads/2025/11/7-1024x1024.jpg.webp',
  'https://natural.clinic/wp-content/uploads/2025/11/6-1024x1024.jpg.webp',
  'https://natural.clinic/wp-content/uploads/2025/11/5-1024x1024.jpg.webp',
  'https://natural.clinic/wp-content/uploads/2025/11/4-1024x1024.jpg.webp',
  'https://natural.clinic/wp-content/uploads/2025/11/3-1024x1024.jpg.webp',
  'https://natural.clinic/wp-content/uploads/2025/11/2-1024x1024.jpg.webp',
  'https://natural.clinic/wp-content/uploads/2025/11/1-1024x1024.jpg.webp',
];
const BARIATRICS_IMGS = [
  'https://natural.clinic/wp-content/uploads/2025/12/rhinoplasty-before-and-after-turkey-2-1024x1024-5-3.webp',
  'https://natural.clinic/wp-content/uploads/2025/12/rhinoplasty-before-and-after-turkey-2-1024x1024-4-2.webp',
  'https://natural.clinic/wp-content/uploads/2025/12/rhinoplasty-before-and-after-turkey-2-1024x1024-3-3.webp',
  'https://natural.clinic/wp-content/uploads/2025/12/rhinoplasty-before-and-after-turkey-2-1024x1024-2-3.webp',
  'https://natural.clinic/wp-content/uploads/2025/12/rhinoplasty-before-and-after-turkey-2-1024x1024-1-3.webp',
];
const BREAST_AUG_IMGS = [
  'https://natural.clinic/wp-content/uploads/2025/12/Breast-Augmentation-before-and-after-10.webp',
  'https://natural.clinic/wp-content/uploads/2025/12/Breast-Augmentation-before-and-after-9.webp',
  'https://natural.clinic/wp-content/uploads/2025/12/Breast-Augmentation-before-and-after-8.webp',
  'https://natural.clinic/wp-content/uploads/2025/12/Breast-Augmentation-before-and-after-7.webp',
  'https://natural.clinic/wp-content/uploads/2025/12/Breast-Augmentation-before-and-after-5.webp',
  'https://natural.clinic/wp-content/uploads/2025/12/Breast-Augmentation-before-and-after-4.webp',
  'https://natural.clinic/wp-content/uploads/2025/12/Breast-Augmentation-before-and-after-2.webp',
];
const BREAST_LIFT_IMGS = [
  'https://natural.clinic/wp-content/uploads/2025/12/Breast-Lifting-before-and-after-5.webp',
  'https://natural.clinic/wp-content/uploads/2025/12/Breast-Lifting-before-and-after-4.webp',
  'https://natural.clinic/wp-content/uploads/2025/12/Breast-Lifting-before-and-after-3.webp',
  'https://natural.clinic/wp-content/uploads/2025/12/Breast-Lifting-before-and-after-2.webp',
  'https://natural.clinic/wp-content/uploads/2025/12/Breast-Lifting-before-and-after-1.webp',
];
const HAIR_IMGS = [
  'https://natural.clinic/wp-content/uploads/2025/12/rhinoplasty-before-and-after-turkey-2-1024x1024-5-2.webp',
  'https://natural.clinic/wp-content/uploads/2025/12/rhinoplasty-before-and-after-turkey-2-1024x1024-4-1.webp',
  'https://natural.clinic/wp-content/uploads/2025/12/rhinoplasty-before-and-after-turkey-2-1024x1024-3-2.webp',
  'https://natural.clinic/wp-content/uploads/2025/12/rhinoplasty-before-and-after-turkey-2-1024x1024-2-2.webp',
  'https://natural.clinic/wp-content/uploads/2025/12/rhinoplasty-before-and-after-turkey-2-1024x1024-1-2.webp',
];
const DENTISTRY_IMGS = [
  'https://natural.clinic/wp-content/uploads/2025/12/rhinoplasty-before-and-after-turkey-2-1024x1024-4.webp',
  'https://natural.clinic/wp-content/uploads/2025/12/rhinoplasty-before-and-after-turkey-2-1024x1024-1-2.webp',
  'https://images.unsplash.com/photo-1606811841689-23dfddce3e95?w=1024&q=85',
  'https://images.unsplash.com/photo-1675526607070-f5cbd71dde92?w=1024&q=85',
  'https://images.unsplash.com/photo-1588776814546-1ffcf47267a5?w=1024&q=85',
  'https://images.unsplash.com/photo-1588776814441-779f58e93a93?w=1024&q=85',
];

// Treatment-specific image galleries per slug.
// Each gallery has: hero (main) and images[] (before/after photos for carousel).
export const treatmentGalleries = {
  // FACE
  'rhinoplasty':        { hero: FACE_IMGS[0], images: FACE_IMGS },
  'facelift':           { hero: FACE_IMGS[7], images: [FACE_IMGS[7], ...FACE_IMGS.slice(0, 6)] },
  'eyelid-surgery':     { hero: FACE_IMGS[1], images: [FACE_IMGS[1], FACE_IMGS[2], FACE_IMGS[3], FACE_IMGS[0], FACE_IMGS[5], FACE_IMGS[7]] },
  'otoplasty':          { hero: FACE_IMGS[2], images: [FACE_IMGS[2], FACE_IMGS[6], FACE_IMGS[3], FACE_IMGS[1], FACE_IMGS[5], FACE_IMGS[0]] },
  'neck-lift':          { hero: FACE_IMGS[7], images: [FACE_IMGS[7], FACE_IMGS[3], FACE_IMGS[4], FACE_IMGS[0], FACE_IMGS[6]] },
  'chin-augmentation':  { hero: FACE_IMGS[6], images: [FACE_IMGS[6], FACE_IMGS[2], FACE_IMGS[0], FACE_IMGS[1], FACE_IMGS[5]] },
  // HAIR
  'dhi-hair-transplant':  { hero: HAIR_IMGS[0], images: HAIR_IMGS },
  'sapphire-fue':         { hero: HAIR_IMGS[1], images: [HAIR_IMGS[1], HAIR_IMGS[0], HAIR_IMGS[2], HAIR_IMGS[3], HAIR_IMGS[4]] },
  'afro-hair-transplant': { hero: HAIR_IMGS[2], images: [HAIR_IMGS[2], HAIR_IMGS[3], HAIR_IMGS[0], HAIR_IMGS[1], HAIR_IMGS[4]] },
  'beard-transplant':     { hero: HAIR_IMGS[3], images: [HAIR_IMGS[3], HAIR_IMGS[4], HAIR_IMGS[1], HAIR_IMGS[0], HAIR_IMGS[2]] },
  'eyebrow-transplant':   { hero: HAIR_IMGS[4], images: [HAIR_IMGS[4], HAIR_IMGS[0], HAIR_IMGS[1], HAIR_IMGS[2], HAIR_IMGS[3]] },
  'prp-therapy':          { hero: HAIR_IMGS[0], images: HAIR_IMGS },
  // DENTISTRY
  'hollywood-smile':  { hero: DENTISTRY_IMGS[0], images: DENTISTRY_IMGS },
  'veneers':          { hero: DENTISTRY_IMGS[2], images: [DENTISTRY_IMGS[2], DENTISTRY_IMGS[0], DENTISTRY_IMGS[3], DENTISTRY_IMGS[4], DENTISTRY_IMGS[5]] },
  'dental-implants':  { hero: DENTISTRY_IMGS[3], images: [DENTISTRY_IMGS[3], DENTISTRY_IMGS[0], DENTISTRY_IMGS[2], DENTISTRY_IMGS[4], DENTISTRY_IMGS[5]] },
  'teeth-whitening':  { hero: DENTISTRY_IMGS[4], images: [DENTISTRY_IMGS[4], DENTISTRY_IMGS[2], DENTISTRY_IMGS[3], DENTISTRY_IMGS[0], DENTISTRY_IMGS[5]] },
  'dental-crowns':    { hero: DENTISTRY_IMGS[5], images: [DENTISTRY_IMGS[5], DENTISTRY_IMGS[0], DENTISTRY_IMGS[2], DENTISTRY_IMGS[3], DENTISTRY_IMGS[4]] },
  'orthodontics':     { hero: DENTISTRY_IMGS[1], images: [DENTISTRY_IMGS[1], DENTISTRY_IMGS[0], DENTISTRY_IMGS[2], DENTISTRY_IMGS[3], DENTISTRY_IMGS[5]] },
  // BODY
  'tummy-tuck':        { hero: BODY_IMGS[7], images: [BODY_IMGS[7], BODY_IMGS[8], BODY_IMGS[9], BODY_IMGS[2], BODY_IMGS[4], BODY_IMGS[5]] },
  'liposuction':       { hero: BODY_IMGS[1], images: BODY_IMGS },
  'bbl':               { hero: BODY_IMGS[5], images: [BODY_IMGS[5], BODY_IMGS[4], BODY_IMGS[8], BODY_IMGS[9], BODY_IMGS[6], BODY_IMGS[2]] },
  'mommy-makeover':    { hero: BODY_IMGS[2], images: [BODY_IMGS[2], BODY_IMGS[5], BODY_IMGS[7], BODY_IMGS[8], BODY_IMGS[4], BODY_IMGS[1]] },
  'labiaplasty':       { hero: BODY_IMGS[9], images: [BODY_IMGS[9], BODY_IMGS[4], BODY_IMGS[5], BODY_IMGS[8], BODY_IMGS[2]] },
  'penis-enlargement': { hero: BODY_IMGS[0], images: [BODY_IMGS[0], BODY_IMGS[7], BODY_IMGS[3], BODY_IMGS[1], BODY_IMGS[6]] },
  // BARIATRICS
  'gastric-sleeve':      { hero: BARIATRICS_IMGS[0], images: BARIATRICS_IMGS },
  'gastric-bypass':      { hero: BARIATRICS_IMGS[1], images: [BARIATRICS_IMGS[1], BARIATRICS_IMGS[0], BARIATRICS_IMGS[2], BARIATRICS_IMGS[3], BARIATRICS_IMGS[4]] },
  'gastric-balloon':     { hero: BARIATRICS_IMGS[2], images: [BARIATRICS_IMGS[2], BARIATRICS_IMGS[3], BARIATRICS_IMGS[4], BARIATRICS_IMGS[0], BARIATRICS_IMGS[1]] },
  'mini-gastric-bypass': { hero: BARIATRICS_IMGS[3], images: [BARIATRICS_IMGS[3], BARIATRICS_IMGS[4], BARIATRICS_IMGS[0], BARIATRICS_IMGS[1], BARIATRICS_IMGS[2]] },
  // BREAST
  'breast-augmentation': { hero: BREAST_AUG_IMGS[0], images: BREAST_AUG_IMGS },
  'breast-lift':         { hero: BREAST_LIFT_IMGS[0], images: BREAST_LIFT_IMGS },
  'breast-reduction':    { hero: BREAST_LIFT_IMGS[1], images: [BREAST_LIFT_IMGS[1], BREAST_LIFT_IMGS[2], BREAST_AUG_IMGS[0], BREAST_AUG_IMGS[1], BREAST_LIFT_IMGS[0]] },
  'gynecomastia':        { hero: BODY_IMGS[0], images: [BODY_IMGS[0], BODY_IMGS[3], BODY_IMGS[7], BREAST_AUG_IMGS[5], BREAST_LIFT_IMGS[2]] },
};

// Per-treatment guide content: "Your Guide to Successful [Treatment]"
// Keys: heading (two-line accent), description, stats (6 items matching reference layout)
const guide = (heading, description, stats) => ({ heading, description, stats });
const G = { // standard labels re-used across treatments
  dur: 'Duration of Procedure',
  ret: 'Return to Activities',
  hosp: 'Hospitalization Duration',
  rec: 'Complete Recovery',
  res: 'Anticipated Results',
  mob: 'Mobility',
};

export const treatmentGuides = {
  // FACE
  'rhinoplasty': guide(
    'Successful Rhinoplasty',
    'Reshape your nose with proven surgical techniques tailored to your facial harmony. Our board-certified surgeons in Istanbul deliver natural, long-lasting results that preserve your identity while enhancing balance, breathing and confidence.',
    [[G.dur,'2\u20134 hours'],[G.ret,'7\u201310 days'],[G.hosp,'1 night'],[G.rec,'6\u201312 months'],[G.res,'12 months'],[G.mob,'3 days']]
  ),
  'facelift': guide(
    'Successful Facelift',
    'Turn back the clock with a customized facelift that smooths wrinkles and restores youthful contours. Our surgeons use advanced deep-plane techniques for results that look refreshed, never pulled.',
    [[G.dur,'3\u20135 hours'],[G.ret,'10\u201314 days'],[G.hosp,'1\u20132 nights'],[G.rec,'3\u20136 months'],[G.res,'8\u201312 years'],[G.mob,'5 days']]
  ),
  'eyelid-surgery': guide(
    'Successful Eyelid Surgery',
    'Blepharoplasty refreshes tired eyes by removing excess skin and repositioning fat around the upper and lower lids. The result is a rested, alert expression that looks entirely natural.',
    [[G.dur,'1\u20132 hours'],[G.ret,'7 days'],[G.hosp,'Day case'],[G.rec,'2\u20133 months'],[G.res,'5\u201310 years'],[G.mob,'2 days']]
  ),
  'otoplasty': guide(
    'Successful Otoplasty',
    'Otoplasty gently reshapes protruding ears for a balanced, proportionate look. A precise, minimally invasive technique delivers permanent results with a quick recovery.',
    [[G.dur,'1\u20132 hours'],[G.ret,'5\u20137 days'],[G.hosp,'Day case'],[G.rec,'2 months'],[G.res,'Permanent'],[G.mob,'1 day']]
  ),
  'neck-lift': guide(
    'Successful Neck Lift',
    'A neck lift tightens loose skin and contours the jawline, erasing the signs of aging below the chin. Our surgeons combine muscle tightening with skin redraping for a seamless, youthful profile.',
    [[G.dur,'2\u20134 hours'],[G.ret,'10\u201314 days'],[G.hosp,'1 night'],[G.rec,'3\u20136 months'],[G.res,'10+ years'],[G.mob,'4 days']]
  ),
  'chin-augmentation': guide(
    'Successful Chin Augmentation',
    'Strengthen your profile with a precisely sized chin implant or osseous genioplasty. The result is a balanced facial harmony that enhances every angle.',
    [[G.dur,'1\u20132 hours'],[G.ret,'7 days'],[G.hosp,'Day case'],[G.rec,'2\u20133 months'],[G.res,'Permanent'],[G.mob,'2 days']]
  ),
  // HAIR
  'dhi-hair-transplant': guide(
    'Successful DHI Hair Transplant',
    'Direct Hair Implantation (DHI) places each graft with a Choi pen for the densest, most natural-looking hairline possible. No shaving required, minimal downtime, lifetime results.',
    [[G.dur,'6\u20138 hours'],[G.ret,'3 days'],[G.hosp,'Day case'],[G.rec,'12\u201318 months'],[G.res,'Lifetime'],[G.mob,'1 day']]
  ),
  'sapphire-fue': guide(
    'Successful Sapphire FUE',
    'Sapphire FUE uses ultra-precise sapphire blades to create micro-channels, allowing ultra-dense packing with faster healing and minimal scarring.',
    [[G.dur,'6\u20138 hours'],[G.ret,'3 days'],[G.hosp,'Day case'],[G.rec,'12 months'],[G.res,'Lifetime'],[G.mob,'1 day']]
  ),
  'afro-hair-transplant': guide(
    'Successful Afro Hair Transplant',
    'Specialized technique for curly and coiled hair types. Our experts use enlarged incisions and careful extraction angles to protect curly follicles and achieve natural coverage.',
    [[G.dur,'7\u20139 hours'],[G.ret,'3 days'],[G.hosp,'Day case'],[G.rec,'12\u201318 months'],[G.res,'Lifetime'],[G.mob,'1 day']]
  ),
  'beard-transplant': guide(
    'Successful Beard Transplant',
    'Fill in patchy areas or design a full beard using your own follicles. Results grow in thick, even and permanent, ready for shaping like natural facial hair.',
    [[G.dur,'4\u20136 hours'],[G.ret,'3 days'],[G.hosp,'Day case'],[G.rec,'8\u201312 months'],[G.res,'Lifetime'],[G.mob,'1 day']]
  ),
  'eyebrow-transplant': guide(
    'Successful Eyebrow Transplant',
    'Restore thin or over-plucked brows with individually placed grafts, customized to your preferred shape, density and angle.',
    [[G.dur,'2\u20134 hours'],[G.ret,'2 days'],[G.hosp,'Day case'],[G.rec,'6\u20139 months'],[G.res,'Lifetime'],[G.mob,'Immediate']]
  ),
  'prp-therapy': guide(
    'Successful PRP Therapy',
    'Platelet-Rich Plasma uses your own growth factors to stimulate follicle regeneration, reduce shedding and strengthen existing hair.',
    [[G.dur,'45 minutes'],[G.ret,'Same day'],[G.hosp,'None'],[G.rec,'N/A'],[G.res,'3\u20136 months per cycle'],[G.mob,'Immediate']]
  ),
  // DENTISTRY
  'hollywood-smile': guide(
    'Successful Hollywood Smile',
    'A complete smile makeover combining veneers, crowns and whitening for a picture-perfect result. Custom-designed to match your face for cinema-worthy confidence.',
    [[G.dur,'3\u20135 days'],[G.ret,'Immediate'],[G.hosp,'None'],[G.rec,'1 week'],[G.res,'15\u201320 years'],[G.mob,'Immediate']]
  ),
  'veneers': guide(
    'Successful Veneers',
    'Ultra-thin porcelain or e-max veneers bonded to your natural teeth for a flawless, bright and perfectly shaped smile.',
    [[G.dur,'3\u20135 days'],[G.ret,'Immediate'],[G.hosp,'None'],[G.rec,'1 week'],[G.res,'15\u201320 years'],[G.mob,'Immediate']]
  ),
  'dental-implants': guide(
    'Successful Dental Implants',
    'Titanium roots permanently integrated with your jaw bone, topped with lifelike crowns for a stable, lifetime tooth replacement.',
    [[G.dur,'1\u20132 hours / implant'],[G.ret,'2 days'],[G.hosp,'None'],[G.rec,'3\u20136 months'],[G.res,'Lifetime'],[G.mob,'Immediate']]
  ),
  'teeth-whitening': guide(
    'Successful Teeth Whitening',
    'Professional in-clinic bleaching lightens teeth up to 8 shades in a single session, safely and with long-lasting results.',
    [[G.dur,'45\u201360 minutes'],[G.ret,'Immediate'],[G.hosp,'None'],[G.rec,'Immediate'],[G.res,'1\u20132 years'],[G.mob,'Immediate']]
  ),
  'dental-crowns': guide(
    'Successful Dental Crowns',
    'Zirconium and e-max crowns restore damaged teeth with natural translucency, strength and decade-long durability.',
    [[G.dur,'3\u20135 days'],[G.ret,'Immediate'],[G.hosp,'None'],[G.rec,'1 week'],[G.res,'10\u201315 years'],[G.mob,'Immediate']]
  ),
  'orthodontics': guide(
    'Successful Orthodontics',
    'Clear aligners or discreet brackets gently move teeth into their ideal position, improving both aesthetics and bite function.',
    [[G.dur,'6\u201324 months'],[G.ret,'Immediate'],[G.hosp,'None'],[G.rec,'N/A'],[G.res,'Lifetime with retainer'],[G.mob,'Immediate']]
  ),
  // BODY
  'tummy-tuck': guide(
    'Successful Tummy Tuck',
    'Abdominoplasty removes excess skin and fat while tightening the underlying muscles, delivering a flatter, firmer abdomen and a redefined waistline.',
    [[G.dur,'3\u20135 hours'],[G.ret,'2\u20133 weeks'],[G.hosp,'2 nights'],[G.rec,'3\u20136 months'],[G.res,'Long-term'],[G.mob,'7 days']]
  ),
  'liposuction': guide(
    'Successful Body Sculpting',
    'Struggling with areas of persistent fat? Liposuction at Gold Care Esthetic targets stubborn deposits on the abdomen, thighs, arms or flanks for a contoured, athletic silhouette.',
    [[G.dur,'1\u20133 hours'],[G.ret,'7 days'],[G.hosp,'1 night'],[G.rec,'3\u20136 months'],[G.res,'6\u201312 months'],[G.mob,'7 days']]
  ),
  'bbl': guide(
    'Successful Brazilian Butt Lift',
    'A BBL transfers your own purified fat to sculpt fuller, rounder and naturally shaped buttocks while slimming the waist and flanks in the same session.',
    [[G.dur,'3\u20134 hours'],[G.ret,'2 weeks'],[G.hosp,'1 night'],[G.rec,'6 months'],[G.res,'Long-term'],[G.mob,'10 days']]
  ),
  'mommy-makeover': guide(
    'Successful Mommy Makeover',
    'A fully customized combination of tummy tuck, breast enhancement and liposuction to restore your pre-pregnancy shape in a single recovery.',
    [[G.dur,'4\u20136 hours'],[G.ret,'3\u20134 weeks'],[G.hosp,'2 nights'],[G.rec,'6 months'],[G.res,'Long-term'],[G.mob,'10 days']]
  ),
  'labiaplasty': guide(
    'Successful Labiaplasty',
    'A discreet, delicate procedure to reshape the labia for improved comfort, symmetry and confidence, performed by specialized female surgeons.',
    [[G.dur,'1\u20132 hours'],[G.ret,'7\u201310 days'],[G.hosp,'Day case'],[G.rec,'6 weeks'],[G.res,'Permanent'],[G.mob,'3 days']]
  ),
  'penis-enlargement': guide(
    'Successful Penile Enhancement',
    'State-of-the-art penile enhancement techniques (girth, length and/or implants) tailored to your anatomy and goals, performed by leading urologists.',
    [[G.dur,'1\u20133 hours'],[G.ret,'10\u201314 days'],[G.hosp,'1 night'],[G.rec,'3 months'],[G.res,'Permanent'],[G.mob,'7 days']]
  ),
  // BARIATRICS
  'gastric-sleeve': guide(
    'Successful Gastric Sleeve',
    'Remove 75\u201385% of the stomach to dramatically reduce hunger hormones and portion size, delivering sustainable weight loss of 60\u201370% of excess weight.',
    [[G.dur,'1\u20132 hours'],[G.ret,'3\u20134 weeks'],[G.hosp,'3 nights'],[G.rec,'3\u20136 months'],[G.res,'Lifetime'],[G.mob,'3 days']]
  ),
  'gastric-bypass': guide(
    'Successful Gastric Bypass',
    'Roux-en-Y bypass both restricts intake and reduces absorption, averaging 70\u201380% excess weight loss and dramatic resolution of diabetes and hypertension.',
    [[G.dur,'2\u20133 hours'],[G.ret,'4 weeks'],[G.hosp,'3\u20134 nights'],[G.rec,'6 months'],[G.res,'Lifetime'],[G.mob,'4 days']]
  ),
  'gastric-balloon': guide(
    'Successful Gastric Balloon',
    'A non-surgical silicone balloon is placed in the stomach to promote early satiety and reset your eating habits for 6\u201312 months.',
    [[G.dur,'20\u201330 minutes'],[G.ret,'2 days'],[G.hosp,'Day case'],[G.rec,'1 week'],[G.res,'6\u201312 months'],[G.mob,'Immediate']]
  ),
  'mini-gastric-bypass': guide(
    'Successful Mini Gastric Bypass',
    'A simpler, shorter one-anastomosis bypass offering comparable weight loss with lower complication rates and a faster operative time.',
    [[G.dur,'1\u20132 hours'],[G.ret,'3 weeks'],[G.hosp,'3 nights'],[G.rec,'6 months'],[G.res,'Lifetime'],[G.mob,'3 days']]
  ),
  // BREAST
  'breast-augmentation': guide(
    'Successful Breast Augmentation',
    'Shape and size the breasts with premium silicone implants or fat transfer, carefully tailored to your body frame for beautifully natural results.',
    [[G.dur,'1\u20132 hours'],[G.ret,'7\u201310 days'],[G.hosp,'1 night'],[G.rec,'3 months'],[G.res,'10\u201315 years'],[G.mob,'4 days']]
  ),
  'breast-lift': guide(
    'Successful Breast Lift',
    'Mastopexy raises and reshapes sagging breasts by removing excess skin, repositioning the nipple and restoring youthful projection.',
    [[G.dur,'2\u20133 hours'],[G.ret,'2 weeks'],[G.hosp,'1 night'],[G.rec,'3 months'],[G.res,'10+ years'],[G.mob,'5 days']]
  ),
  'breast-reduction': guide(
    'Successful Breast Reduction',
    'Relieve back pain and improve posture by reducing breast volume while lifting and reshaping for a proportionate, comfortable silhouette.',
    [[G.dur,'2\u20134 hours'],[G.ret,'2\u20133 weeks'],[G.hosp,'1\u20132 nights'],[G.rec,'3\u20136 months'],[G.res,'Long-term'],[G.mob,'5 days']]
  ),
  'gynecomastia': guide(
    'Successful Gynecomastia Surgery',
    'Remove excess glandular tissue and fat from the male chest with minimal scarring for a flat, masculine and confident contour.',
    [[G.dur,'1\u20132 hours'],[G.ret,'7\u201310 days'],[G.hosp,'Day case'],[G.rec,'2\u20133 months'],[G.res,'Permanent'],[G.mob,'3 days']]
  ),
};


// Mock data for Gold Care Esthetic - replica of natural.clinic

export const brand = {
  name: 'Gold Care Esthetic',
  domain: 'goldcareclinic.com',
  tagline: 'Your Journey To Perfection!',
  email: 'info@goldcareclinic.com',
  instagram: 'https://www.instagram.com/goldcare.clinic',
  instagramHandle: '@goldcare.clinic',
  rating: '5.0/5',
  happyPatients: '+100,000',
  countries: '+80',
  phones: [
    { label: 'Turkey', value: '+90 531 377 54 19', flag: '\ud83c\uddf9\ud83c\uddf7', tel: '+905313775419' },
    { label: 'Morocco', value: '+212 779 31 85 64', flag: '\ud83c\uddf2\ud83c\udde6', tel: '+212779318564' },
  ],
  locations: [
    {
      id: 'tr',
      country: 'Turkey',
      flag: '\ud83c\uddf9\ud83c\uddf7',
      city: 'Istanbul',
      address: 'G\u00fcm\u00fc\u015fpala, \u0130ske\u00e7e Cd. No:64, 34320 Avc\u0131lar/\u0130stanbul, T\u00fcrkiye',
      phone: '+90 531 377 54 19',
      tel: '+905313775419',
      mapUrl: 'https://www.google.com/maps/search/?api=1&query=G%C3%BCm%C3%BC%C5%9Fpala%2C+%C4%B0ske%C3%A7e+Cd.+No%3A64%2C+34320+Avc%C4%B1lar%2F%C4%B0stanbul',
      tagline: 'Headquarters \u00b7 Est. in Istanbul',
    },
    {
      id: 'ma',
      country: 'Morocco',
      flag: '\ud83c\uddf2\ud83c\udde6',
      city: 'Casablanca',
      address: 'Golf City Prestigia, Bouskoura, Casablanca',
      phone: '+212 779 31 85 64',
      tel: '+212779318564',
      mapUrl: 'https://www.google.com/maps/search/?api=1&query=Golf+City+Prestigia%2C+Bouskoura%2C+Casablanca',
      tagline: 'North Africa & Europe hub',
    },
  ],
};

export const aboutStory = {
  eyebrow: 'About Gold Care Esthetic',
  title: 'A complete medical experience, beyond borders.',
  paragraphs: [
    'Gold Care Esthetic was founded with a clear vision: to offer patients a safe, luxurious, and fully guided medical experience beyond borders.',
    'Starting from a strong base in Istanbul, one of the world\u2019s leading destinations for aesthetic medicine, Gold Care Esthetic quickly built a reputation for delivering high-quality results and personalized care.',
    'As the demand grew, the clinic expanded its presence to Morocco, bringing the same international standards and premium services closer to patients in North Africa and Europe.',
    'Today, Gold Care Esthetic operates between Turkey and Morocco, connecting patients with expert surgeons while managing every detail of their journey \u2014 from consultation to recovery.',
    'More than a clinic, Gold Care is a complete medical experience, where trust, precision, and patient satisfaction come first.',
  ],
  pillars: [
    { title: 'Trust', text: 'Every patient is guided with transparency from first consultation to full recovery.' },
    { title: 'Precision', text: 'Board-certified surgeons and modern facilities deliver predictable, natural results.' },
    { title: 'Patient First', text: 'Concierge-level care across Turkey and Morocco \u2014 your journey, handled end-to-end.' },
  ],
};

export const navItems = [
  { label: 'Home', i18nKey: 'nav.home', href: '/', icon: 'home' },
  { label: 'About Us', i18nKey: 'nav.about', href: '/#about' },
  { label: 'Services', i18nKey: 'nav.services', href: '/services', hasMenu: true },
  { label: 'Blog', i18nKey: 'nav.blog', href: '/#blog' },
  { label: 'Contact us', i18nKey: 'nav.contact', href: '/#contact' },
];

// Service categories + individual treatments.
// Each treatment has its own page at /treatments/:slug
export const serviceCategories = [
  {
    id: 'body',
    label: 'Body Aesthetic',
    image: 'https://images.unsplash.com/photo-1549445069-d1125f7a129c?w=800&q=75',
    treatments: [
      { slug: 'tummy-tuck', label: 'Tummy Tuck' },
      { slug: 'liposuction', label: 'Liposuction' },
      { slug: 'bbl', label: 'BBL' },
      { slug: 'mommy-makeover', label: 'Mommy Makeover' },
      { slug: 'labiaplasty', label: 'Labiaplasty' },
      { slug: 'penis-enlargement', label: 'Penis Enlargement' },
    ],
  },
  {
    id: 'bariatrics',
    label: 'Bariatrics',
    image: 'https://images.unsplash.com/photo-1591384640699-9a85bd036da2?w=800&q=75',
    treatments: [
      { slug: 'gastric-sleeve', label: 'Gastric Sleeve' },
      { slug: 'gastric-bypass', label: 'Gastric Bypass' },
      { slug: 'gastric-balloon', label: 'Gastric Balloon' },
      { slug: 'mini-gastric-bypass', label: 'Mini Gastric Bypass' },
    ],
  },
  {
    id: 'breast',
    label: 'Breast Aesthetic',
    image: 'https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?w=800&q=75',
    treatments: [
      { slug: 'breast-augmentation', label: 'Breast Augmentation' },
      { slug: 'breast-lift', label: 'Breast Lift' },
      { slug: 'breast-reduction', label: 'Breast Reduction' },
      { slug: 'gynecomastia', label: 'Gynecomastia' },
    ],
  },
  {
    id: 'face',
    label: 'Face Aesthetic',
    image: 'https://images.unsplash.com/photo-1552693673-1bf958298935?w=800&q=75',
    treatments: [
      { slug: 'rhinoplasty', label: 'Rhinoplasty' },
      { slug: 'facelift', label: 'Facelift' },
      { slug: 'eyelid-surgery', label: 'Eyelid Surgery' },
      { slug: 'otoplasty', label: 'Otoplasty' },
      { slug: 'neck-lift', label: 'Neck Lift' },
      { slug: 'chin-augmentation', label: 'Chin Augmentation' },
    ],
  },
  {
    id: 'hair',
    label: 'Hair Treatments',
    image: 'https://images.unsplash.com/photo-1512663150964-d8f43c899f76?w=800&q=75',
    treatments: [
      { slug: 'dhi-hair-transplant', label: 'DHI Hair Transplant' },
      { slug: 'sapphire-fue', label: 'Sapphire FUE' },
      { slug: 'afro-hair-transplant', label: 'Afro Hair Transplant' },
      { slug: 'beard-transplant', label: 'Beard Transplant' },
      { slug: 'eyebrow-transplant', label: 'Eyebrow Transplant' },
      { slug: 'prp-therapy', label: 'PRP Therapy' },
    ],
  },
  {
    id: 'dentistry',
    label: 'Dentistry',
    image: 'https://images.unsplash.com/photo-1675526607070-f5cbd71dde92?w=800&q=75',
    treatments: [
      { slug: 'hollywood-smile', label: 'Hollywood Smile' },
      { slug: 'veneers', label: 'Veneers' },
      { slug: 'dental-implants', label: 'Dental Implants' },
      { slug: 'teeth-whitening', label: 'Teeth Whitening' },
      { slug: 'dental-crowns', label: 'Dental Crowns' },
      { slug: 'orthodontics', label: 'Orthodontics' },
    ],
  },
];

export const findTreatment = (slug) => {
  for (const cat of serviceCategories) {
    const t = cat.treatments.find((x) => x.slug === slug);
    if (t) return { ...t, category: cat };
  }
  return null;
};

export const topBar = [
  { label: 'Articles', href: '#articles' },
  { label: 'Corporate', href: '#corporate' },
  { label: 'Contact us', href: '#contact' },
];

export const beforeAfterCategories = [
  {
    id: 'face',
    label: 'Face Aesthetic',
    i18nKey: 'cat.face',
    images: [
      'https://natural.clinic/wp-content/uploads/2025/12/rhinoplasty-before-and-after-turkey-15-1-1024x1024.jpg.webp',
      'https://natural.clinic/wp-content/uploads/2025/12/rhinoplasty-before-and-after-turkey-16-1024x1024.jpg.webp',
      'https://natural.clinic/wp-content/uploads/2025/12/rhinoplasty-before-and-after-turkey-3-1024x1024.jpg.webp',
      'https://natural.clinic/wp-content/uploads/2025/12/rhinoplasty-before-and-after-turkey-14-1-1024x1024.jpg.webp',
      'https://natural.clinic/wp-content/uploads/2025/12/rhinoplasty-before-and-after-turkey-2-1024x1024-2.webp',
      'https://natural.clinic/wp-content/uploads/2025/12/rhinoplasty-before-and-after-turkey-17-1024x1024.jpg.webp',
      'https://natural.clinic/wp-content/uploads/2025/12/rhinoplasty-before-and-after-turkey-18-1024x1024.jpg.webp',
    ],
  },
  {
    id: 'body',
    label: 'Body Aesthetic',
    i18nKey: 'cat.body',
    images: BODY_IMGS,
  },
  {
    id: 'hair',
    label: 'Hair Treatments',
    i18nKey: 'cat.hair',
    images: [
      'https://natural.clinic/wp-content/uploads/2025/12/rhinoplasty-before-and-after-turkey-2-1024x1024-5-2.webp',
      'https://natural.clinic/wp-content/uploads/2025/12/rhinoplasty-before-and-after-turkey-2-1024x1024-4-1.webp',
      'https://natural.clinic/wp-content/uploads/2025/12/rhinoplasty-before-and-after-turkey-2-1024x1024-3-2.webp',
      'https://natural.clinic/wp-content/uploads/2025/12/rhinoplasty-before-and-after-turkey-2-1024x1024-2-2.webp',
      'https://natural.clinic/wp-content/uploads/2025/12/rhinoplasty-before-and-after-turkey-2-1024x1024-1-2.webp',
    ],
  },
  {
    id: 'dentistry',
    label: 'Dentistry',
    i18nKey: 'cat.dentistry',
    images: [
      'https://natural.clinic/wp-content/uploads/2025/12/rhinoplasty-before-and-after-turkey-2-1024x1024-4.webp',
      'https://natural.clinic/wp-content/uploads/2025/12/rhinoplasty-before-and-after-turkey-2-1024x1024-2-1.webp',
      'https://natural.clinic/wp-content/uploads/2025/12/rhinoplasty-before-and-after-turkey-2-1024x1024-1-1.webp',
    ],
  },
];

export const services = [
  {
    id: 'hair',
    title: 'Hair Transplant',
    image: 'https://images.unsplash.com/photo-1512663150964-d8f43c899f76?w=800&q=75',
    href: '#hair',
  },
  {
    id: 'face',
    title: 'Cosmetic Surgeries',
    image: 'https://images.unsplash.com/photo-1552693673-1bf958298935?w=800&q=75',
    href: '#face',
  },
  {
    id: 'dentistry',
    title: 'Dentistry',
    image: 'https://images.unsplash.com/photo-1675526607070-f5cbd71dde92?w=800&q=75',
    href: '#dentistry',
  },
  {
    id: 'body',
    title: 'Body Aesthetics',
    image: 'https://images.unsplash.com/photo-1549445069-d1125f7a129c?w=800&q=75',
    href: '#body',
  },
  {
    id: 'bariatrics',
    title: 'Bariatrics',
    image: 'https://images.unsplash.com/photo-1591384640699-9a85bd036da2?w=800&q=75',
    href: '#bariatrics',
  },
  {
    id: 'breast',
    title: 'Breast Aesthetics',
    image: 'https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?w=800&q=75',
    href: '#breast',
  },
];

export const clinicHighlights = [
  {
    id: 'clinic',
    label: 'Gold Care Esthetic',
    images: [
      'https://natural.clinic/wp-content/uploads/2025/12/natural-clinic-21-1011x1024-1.webp',
      'https://natural.clinic/wp-content/uploads/2025/12/natural-clinic-13-1011x1024-1.webp',
      'https://natural.clinic/wp-content/uploads/2025/12/natural-clinic-16-1011x1024-1.webp',
      'https://natural.clinic/wp-content/uploads/2025/12/Copy-of-DSC02454-1.webp',
    ],
  },
  {
    id: 'suits',
    label: 'Gold Suites',
    images: [
      'https://natural.clinic/wp-content/uploads/2025/12/suites-5-1011x1024-1.webp',
      'https://natural.clinic/wp-content/uploads/2025/12/suites-4-1011x1024-1.webp',
      'https://natural.clinic/wp-content/uploads/2025/12/suites-3-1011x1024-1.webp',
      'https://natural.clinic/wp-content/uploads/2025/12/suites-2-1011x1024-1.webp',
      'https://natural.clinic/wp-content/uploads/2025/12/suites-1-1011x1024-1.webp',
    ],
  },
  {
    id: 'operation',
    label: 'Operation Rooms',
    images: [
      'https://natural.clinic/wp-content/uploads/2025/12/natural-clinic-operation-room-11-1011x1024-1.webp',
      'https://natural.clinic/wp-content/uploads/2025/12/natural-clinic-operation-room-7-1011x1024-1.webp',
      'https://natural.clinic/wp-content/uploads/2025/12/natural-clinic-operation-room-6-1011x1024-1.webp',
      'https://natural.clinic/wp-content/uploads/2025/12/natural-clinic-operation-room-4-1011x1024-1.webp',
      'https://natural.clinic/wp-content/uploads/2025/12/natural-clinic-operation-room-3-1011x1024-1.webp',
    ],
  },
];

// Instagram profile link for the Journey section (@goldcare.clinic)
export const instagramProfile = 'https://www.instagram.com/goldcare.clinic';

// Journey reels cards — realistic reel covers that link out to the Instagram profile.
// Actual Instagram reel URLs cannot be auto-embedded without the clinic's reel permalinks,
// so each card opens the Instagram profile in a new tab.
export const journeyReels = [
  {
    thumb: 'https://images.unsplash.com/photo-1606811841689-23dfddce3e95?w=600&q=75',
    label: 'Hollywood Smile Makeover',
    views: 'Watch on Instagram',
  },
  {
    thumb: 'https://images.unsplash.com/photo-1512663150964-d8f43c899f76?w=600&q=75',
    label: 'Hair Transplant \u00b7 Day 1 vs Month 6',
    views: 'Watch on Instagram',
  },
  {
    thumb: 'https://images.unsplash.com/photo-1552693673-1bf958298935?w=600&q=75',
    label: 'Rhinoplasty Journey',
    views: 'Watch on Instagram',
  },
  {
    thumb: 'https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=600&q=75',
    label: 'Meet Our Surgeons',
    views: 'Watch on Instagram',
  },
  {
    thumb: 'https://images.unsplash.com/photo-1591384640699-9a85bd036da2?w=600&q=75',
    label: 'Bariatric Transformation',
    views: 'Watch on Instagram',
  },
  {
    thumb: 'https://images.unsplash.com/photo-1549445069-d1125f7a129c?w=600&q=75',
    label: 'Liposuction \u00b7 Real Results',
    views: 'Watch on Instagram',
  },
  {
    thumb: 'https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?w=600&q=75',
    label: 'Breast Aesthetics Story',
    views: 'Watch on Instagram',
  },
];

// Real Google-style reviews (sourced from public Wupdoc profile for Gold Care Esthetic).
export const testimonials = [
  {
    name: 'Tanya Mills',
    country: 'Turkey',
    flag: '\ud83c\uddf9\ud83c\uddf7',
    date: '26 June 2022',
    rating: 5,
    treatment: 'Plastic Surgery',
    text: 'I\u2019ve had operations in the past, but I must say, my experience with Gold Care Esthetic was by far the best. I\u2019m very happy with the results, thank you.',
    avatar: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=200&q=75&fit=crop&crop=faces',
  },
  {
    name: 'Aymane Ait Ben Abderrahmane',
    country: 'Turkey',
    flag: '\ud83c\uddf9\ud83c\uddf7',
    date: '24 June 2022',
    rating: 5,
    treatment: 'Aesthetic Care',
    text: 'I was really impressed by how efficient, kind and helpful the staff was. Their services exceeded my expectations. I highly recommend Gold Care Esthetic for you.',
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&q=75&fit=crop&crop=faces',
  },
  {
    name: 'Carla Demontis',
    country: 'France',
    flag: '\ud83c\uddeb\ud83c\uddf7',
    date: '04 July 2022',
    rating: 5,
    treatment: 'Cosmetic Surgery',
    text: 'Tout le monde est tr\u00e8s gentil, vous me mettez \u00e0 l\u2019aise. La meilleure clinique, je vous recommande. L\u2019op\u00e9ration s\u2019est tr\u00e8s bien pass\u00e9e, tout \u00e9tait parfait.',
    avatar: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=200&q=75&fit=crop&crop=faces',
  },
  {
    name: 'Mai Nathalie Togora',
    country: 'Ivory Coast',
    flag: '\ud83c\udde8\ud83c\uddee',
    date: '06 August 2022',
    rating: 5,
    treatment: 'Aesthetic Care',
    text: 'Tr\u00e8s belle collaboration et tr\u00e8s bon travail. Que Dieu continue de vous inspirer.',
    avatar: 'https://images.unsplash.com/photo-1548142813-c348350df52b?w=200&q=75&fit=crop&crop=faces',
  },
  {
    name: 'Anass Boulhaj',
    country: 'France',
    flag: '\ud83c\uddeb\ud83c\uddf7',
    date: '19 October 2023',
    rating: 5,
    treatment: 'Plastic Surgery',
    text: 'Je recommande fortement cette clinique. Accueil chaleureux, \u00e9quipe professionnelle et r\u00e9sultats au rendez-vous. \ud83d\udc4d',
    avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=200&q=75&fit=crop&crop=faces',
  },
];

export const pressLogos = [
  { name: 'BBC', img: 'https://natural.clinic/wp-content/uploads/2025/12/image-389.png' },
  { name: 'Vogue', img: 'https://natural.clinic/wp-content/uploads/2025/12/image-391.png' },
  { name: 'LaLiga', img: 'https://natural.clinic/wp-content/uploads/2025/12/image388.png' },
];

export const pressArticles = [
  {
    title: 'LaLiga and Gold Care Esthetic Partnership',
    excerpt: 'In a groundbreaking move, Gold Care Esthetic proudly announces its official partnership with LaLiga, Spain\u2019s top professional football division.',
    thumb: 'https://natural.clinic/wp-content/uploads/2025/12/Placeholder-2.png',
    logo: 'https://natural.clinic/wp-content/uploads/2025/12/image388.png',
  },
  {
    title: 'Why Should You Get Dental Veneers In Turkey?',
    excerpt: 'Ever wondered how to get that Hollywood smile without breaking the bank? Discover why thousands choose Istanbul for their smile transformation.',
    thumb: 'https://natural.clinic/wp-content/uploads/2025/12/image-2.png',
    logo: 'https://natural.clinic/wp-content/uploads/2025/12/image-391.png',
  },
  {
    title: 'The BBC\u2019s Exclusive Reportage of Gold Care',
    excerpt: 'Napoleon famously said: if the world was an empire, Istanbul would be its capital. If the world was a hospital, Istanbul would be its operations room.',
    thumb: 'https://natural.clinic/wp-content/uploads/2025/12/Placeholder.png',
    logo: 'https://natural.clinic/wp-content/uploads/2025/12/image-389.png',
  },
];

export const blogPosts = [
  {
    title: 'Labiaplasty in Turkey | Cost, Recovery & Results',
    date: 'April 23, 2026',
    excerpt: 'Labiaplasty in Istanbul is a safe and effective cosmetic procedure with world-class surgeons and premium aftercare.',
    image: 'https://natural.clinic/wp-content/uploads/2026/04/unrecognizable-woman-with-perfect-slim-body-keeps-hands-waist-wears-casual-white-top-panties-scaled-900x600.jpg',
  },
  {
    title: 'Abdominoplasty in Turkey: Procedure, Recovery & Results',
    date: 'April 22, 2026',
    excerpt: 'Abdominoplasty in Turkey, also known as a tummy tuck, is a body contouring surgery used to restore a flat, firm abdomen.',
    image: 'https://natural.clinic/wp-content/uploads/2026/04/abdominoplasty-scaled-900x600.jpg',
  },
  {
    title: 'Breast Implants (Boob Job) in Turkey: Natural Results',
    date: 'April 21, 2026',
    excerpt: 'Thinking about a boob job in Turkey but worried about results? Here is everything you need to know about safety and costs.',
    image: 'https://natural.clinic/wp-content/uploads/2026/04/breast_implant_boob_job-scaled-900x600.jpg',
  },
  {
    title: 'Female Hair Transplant: Natural Results & Costs',
    date: 'April 21, 2026',
    excerpt: 'Hair loss in women is not just a cosmetic issue \u2014 it is emotional. Learn how female hair transplant can restore confidence.',
    image: 'https://natural.clinic/wp-content/uploads/2026/04/female-hair-tranplant-cost-scaled-900x600.jpg',
  },
  {
    title: 'Penis Enlargement in Turkey: Methods & Real Results',
    date: 'April 21, 2026',
    excerpt: 'What is Penis Enlargement? Penis enlargement refers to medical and surgical methods designed to enhance size and confidence.',
    image: 'https://natural.clinic/wp-content/uploads/2026/04/Penis-Enlargement-2.png-900x600.webp',
  },
  {
    title: 'Veneers Turkey: Cost, Procedure & Why Patients Choose Turkey',
    date: 'April 16, 2026',
    excerpt: 'Veneers in Turkey have become one of the most sought-after dental treatments worldwide thanks to expert craftsmanship.',
    image: 'https://natural.clinic/wp-content/uploads/2026/04/veneer-turkey-scaled-900x600.jpg',
  },
];

export const celebrities = [
  {
    name: 'Michele Morone',
    blurb: "Michele Morrone's First Time in Turkey!  What He Really Thinks",
    image: 'https://natural.clinic/wp-content/uploads/2025/11/Group-1171275735-2.webp',
  },
  {
    name: 'Elma Aveiro',
    blurb: "Cristiano Ronaldo's sister getting treatment at Gold Care Esthetic",
    image: 'https://natural.clinic/wp-content/uploads/2025/11/Group-1171275737-2.webp',
  },
  {
    name: 'Alexandra Stan',
    blurb: "Inside Alexandra Stan's Skincare Routine at Gold Care Esthetic.",
    image: 'https://natural.clinic/wp-content/uploads/2025/11/Group-1171275736-3.webp',
  },
  {
    name: 'Nicol\u00f2 Zaniolo',
    blurb: "Nicolo Zaniolo's New Smile \u2013 The Truth Behind His Makeover",
    image: 'https://natural.clinic/wp-content/uploads/2025/11/Group-1171275738.webp',
  },
];

export const doctorsCard = {
  title: 'Our Doctors',
  description: 'Gold Care Esthetic, where expertise meets excellence.',
  image: 'https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=900&q=70',
  cta: 'Learn more',
};

export const productsCard = {
  title: 'Gold Care Products',
  description: 'Check our premium products made by Gold Care Esthetic.',
  image: 'https://images.unsplash.com/photo-1556228720-195a672e8a03?w=900&q=70',
  cta: 'Learn more',
};
